import { render, staticRenderFns } from "./InvestmentMetadataActionButtons.vue?vue&type=template&id=6cf64159&scoped=true"
import script from "./InvestmentMetadataActionButtons.vue?vue&type=script&lang=js"
export * from "./InvestmentMetadataActionButtons.vue?vue&type=script&lang=js"
import style0 from "./InvestmentMetadataActionButtons.vue?vue&type=style&index=0&id=6cf64159&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf64159",
  null
  
)

export default component.exports